"use client"

import { useEffect } from 'react'
import { buildAuthSnapshot } from '@/lib/auth-state'
import { createClient } from '@/lib/supabase-browser'
import { useAuthStore } from '@/stores/auth-store'

export function AuthStateProvider() {
  const setLoading = useAuthStore((state) => state.setLoading)
  const setUser = useAuthStore((state) => state.setUser)

  useEffect(() => {
    const supabase = createClient()
    let mounted = true
    setLoading()
    supabase.auth.getSession().then(({ data }) => {
      if (mounted) setUser(buildAuthSnapshot(data.session?.user))
    })
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(buildAuthSnapshot(session?.user))
    })
    return () => {
      mounted = false
      listener.subscription.unsubscribe()
    }
  }, [setLoading, setUser])

  return null
}
